import { render, staticRenderFns } from "./NuestraGente.vue?vue&type=template&id=4f2f502c&"
import script from "./NuestraGente.vue?vue&type=script&lang=js&"
export * from "./NuestraGente.vue?vue&type=script&lang=js&"
import style0 from "./NuestraGente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports